// Formats a US phone number as an E.164 string (e.g. "(333) 456-7890" →
// "+13334567890") for analytics events. Accepts any formatting, with or without
// the leading 1 country code. Returns null when the input isn't a valid-length
// US number so callers can leave the property out of the event.
const formatPhoneE164 = phone => {
  const digits = phone ? String(phone).replace(/\D/g, '') : '';

  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  return null;
};

export default formatPhoneE164;
